// Phase 2 — static price bands + drive time to each resort + Airbnb/Booking deep links.
// Price bands and drive times are rough estimates for a v1 directory (not live data — see plan doc's
// explicit call that live pricing needs an OTA partner API, a business relationship not a build task).
// Drive-time minutes are typical no-traffic estimates; actual time varies a lot with chain control and
// weekend traffic (see the Traffic tab). Resort IDs match src/data/resorts.js.
export const LODGING_TOWNS = [
  {
    townId: "truckee",
    name: "Truckee",
    state: "CA",
    priceBand: "$180–350/night",
    blurb: "Historic downtown, right on I-80 — closest base for the north-shore/I-80 resorts.",
    driveTimeMinutes: {
      "palisades-tahoe": 20,
      northstar: 15,
      "sugar-bowl": 12,
      boreal: 10,
      homewood: 30,
      heavenly: 55,
      kirkwood: 70,
      "mt-rose": 35,
    },
  },
  {
    townId: "kings-beach",
    name: "Kings Beach",
    state: "CA",
    priceBand: "$120–220/night",
    blurb: "Budget-friendly north shore, lake views, casual — a short hop to Northstar or Incline.",
    driveTimeMinutes: {
      "palisades-tahoe": 20,
      northstar: 15,
      "sugar-bowl": 25,
      boreal: 20,
      homewood: 25,
      heavenly: 45,
      kirkwood: 60,
      "mt-rose": 25,
    },
  },
  {
    townId: "tahoe-city",
    name: "Tahoe City",
    state: "CA",
    priceBand: "$160–320/night",
    blurb: "West shore, central — closest base for Palisades Tahoe and Homewood.",
    driveTimeMinutes: {
      "palisades-tahoe": 10,
      northstar: 20,
      "sugar-bowl": 30,
      boreal: 30,
      homewood: 10,
      heavenly: 40,
      kirkwood: 55,
      "mt-rose": 35,
    },
  },
  {
    townId: "south-lake-tahoe",
    name: "South Lake Tahoe",
    state: "CA",
    priceBand: "$100–250/night",
    blurb: "Most lodging supply and nightlife, right by the CA/NV line — closest base for Heavenly/Kirkwood.",
    driveTimeMinutes: {
      "palisades-tahoe": 50,
      northstar: 45,
      "sugar-bowl": 55,
      boreal: 60,
      homewood: 30,
      heavenly: 10,
      kirkwood: 35,
      "mt-rose": 50,
    },
  },
  {
    townId: "incline-village",
    name: "Incline Village",
    state: "NV",
    priceBand: "$200–450/night",
    blurb: "Upscale Nevada-side north shore, quieter — closest base for Mt. Rose.",
    driveTimeMinutes: {
      "palisades-tahoe": 30,
      northstar: 20,
      "sugar-bowl": 35,
      boreal: 30,
      homewood: 25,
      heavenly: 35,
      kirkwood: 55,
      "mt-rose": 15,
    },
  },
];

export const LODGING_TOWNS_BY_ID = Object.fromEntries(LODGING_TOWNS.map((t) => [t.townId, t]));
